import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { startSsoLogin, userManager } from './oidc.js';
import { bridgeSsoSession } from './ssoBridge.js';

/** Completes the Authorization Code + PKCE redirect back from the TIPSSSO portal. */
export function CallbackPage() {
  const navigate = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (!userManager) {
      navigate('/login', { replace: true });
      return;
    }

    userManager
      .signinRedirectCallback()
      .then((user) => {
        // Persist the token immediately; AuthProvider also re-hydrates (and verifies
        // against /auth/me) via the UserLoaded event this callback emits.
        bridgeSsoSession(user);
        const returnTo = (user.state as { returnTo?: string } | undefined)?.returnTo ?? '/';
        navigate(returnTo, { replace: true });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Sign-in failed');
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="route-center">
        <div className="empty-state">
          <h2>Sign-in failed</h2>
          <p>{error}</p>
          <button type="button" className="btn btn--primary" onClick={() => void startSsoLogin('/')}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="route-center">
      <div className="spinner" aria-label="Completing sign-in" />
    </div>
  );
}
